import { Link } from "react-router-dom";

export const Logo = () => (
  <>
    <svg className="w-7 h-7" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <rect width="32" height="32" rx="4" fill="#047857" />
      <path d="M9 7H13V25H9V7Z" fill="white" />
      <path d="M15 16L22 7H26L18 16L26 25H22L15 16Z" fill="#a7f3d0" />
    </svg>
    <span className="text-2xl font-bold tracking-tight text-slate-900">KAJE</span>
  </>
);

export const Header = () => {
  return (
    <>
      <header
        className="border-b border-slate-200 bg-white kaje-body text-xs"
        data-testid="status-header"
      >
        <div className="max-w-6xl mx-auto px-6 py-2.5 flex flex-wrap justify-between items-center gap-2 text-slate-500">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
            <span className="font-medium tracking-wider uppercase text-slate-700">
              Australian Software Development Entity
            </span>
          </div>
          <div className="flex items-center gap-4 kaje-mono">
            <span data-testid="header-abn">ABN 13 907 721 664</span>
            <span className="text-slate-300">|</span>
            <span data-testid="header-owner">Justin Kingaby</span>
          </div>
        </div>
      </header>

      <nav
        className="border-b border-slate-200 bg-white/90 backdrop-blur sticky top-0 z-40"
        data-testid="main-nav"
      >
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
            <Logo />
          </Link>

          <div className="hidden md:flex items-center gap-8 kaje-body text-xs font-semibold uppercase tracking-wider text-slate-600">
            <a href="/#services" className="hover:text-emerald-700 transition-colors" data-testid="nav-services">
              Services
            </a>
            <a href="/#verification" className="hover:text-emerald-700 transition-colors" data-testid="nav-verification">
              ABN &amp; Entity
            </a>
            <a href="/#contact" className="hover:text-emerald-700 transition-colors" data-testid="nav-contact">
              Contact
            </a>
          </div>

          <a
            href="/#contact"
            className="kaje-body px-4 py-2 bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-semibold uppercase tracking-wider rounded transition-colors shadow-sm"
            data-testid="nav-initiate-contact"
          >
            Initiate Contact
          </a>
        </div>
      </nav>
    </>
  );
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-slate-200 bg-slate-100 py-12 px-6 kaje-body text-xs text-slate-500"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <div>
          <p className="font-bold text-xl text-slate-900">KAJE</p>
          <p className="mt-1">Australian Software Development Enterprise</p>
          <p className="kaje-mono text-[11px] text-slate-400 mt-1" data-testid="footer-entity-line">
            Owner: Justin Kingaby &bull; ABN: 13 907 721 664
          </p>
          <p className="kaje-mono text-[11px] text-slate-400 mt-1">
            <a
              href="mailto:kajebiz.store@gmail.com"
              className="hover:text-slate-600"
              data-testid="footer-email-link"
            >
              kajebiz.store@gmail.com
            </a>
          </p>
        </div>
        <div className="flex flex-wrap gap-6 font-medium text-slate-600">
          <a href="/#services" className="hover:text-slate-900" data-testid="footer-services-link">
            Capabilities
          </a>
          <a href="/#verification" className="hover:text-slate-900" data-testid="footer-details-link">
            Business Details
          </a>
          <a href="/#contact" className="hover:text-slate-900" data-testid="footer-contact-link">
            Contact Developer
          </a>
          <Link to="/privacy" className="hover:text-slate-900" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-slate-900" data-testid="footer-terms-link">
            Terms of Service
          </Link>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 pt-6 border-t border-slate-200 flex flex-col sm:flex-row justify-between text-[11px] text-slate-400">
        <p>&copy; {year} KAJE. All rights reserved. Registered in Australia.</p>
        <p>Mobile Apps &bull; AI Tech &bull; Digital Subscriptions</p>
      </div>
    </footer>
  );
};
